import { getRenderer } from '__editor/panelsEditor/components/renderer/renderer';
import { getStage, updateLayersOrder } from '__editor/panelsEditor/components/stage/stage';
import { dispatch, state } from '__common/store';
import { measurementToolModel } from '__editor/googleMapsRoofsSelector/models/measurementTool';
import { RESET_CURRENT_MEASUREMENT } from '__editor/googleMapsRoofsSelector/components/measurementTool/measurementToolActions';

let measurementContainer: PIXI.Container;
export const MEASUREMENT_LAYER_Z_INDEX = 99999;

export function drawingMeasurementToolOnStage() {
  const { measurementTool: { enabled, visible, startingPoint, endingPoint, measurements }, background: { metersPerPixel }, projectConfiguration : { productId, inputUnit } } = state();
  const stage = getStage();
  if (stage) {

    if (!measurementContainer || measurementContainer.parent !== stage) {
      if (!measurementContainer) {
        measurementContainer = new PIXI.Container();
        measurementContainer.sortableChildren = true;
      }
      measurementContainer.zIndex = MEASUREMENT_LAYER_Z_INDEX;
      stage.addChild(measurementContainer);
    }

    // Clear everything inside the container
    measurementContainer.removeChildren();

    if (visible) {
      // Render saved measurements
      measurements.forEach((m, index) => {
        const mModel = measurementToolModel(m.startingPoint, m.endingPoint, stage.scale.x, productId, inputUnit, true, metersPerPixel, index);
        if (mModel) {
          mModel.zIndex = index;
          measurementContainer.addChild(mModel);
        }
      });
    }

    // Render current measurement (the one being drawn)
    if (enabled && startingPoint && endingPoint) {
      const measurementPreview = measurementToolModel(startingPoint, endingPoint, stage.scale.x, productId, inputUnit, true, metersPerPixel);
      if (measurementPreview) {
        measurementPreview.zIndex = 9999;
        measurementContainer.addChild(measurementPreview);
      }
    }

    const renderer = getRenderer();
    if (renderer) {
      stage.children = updateLayersOrder(stage.children);
      renderer.render(stage);
    }
  }
}

export const clearMeasurements = () => {
  const stage = getStage();

  if (stage && measurementContainer) {
    measurementContainer.removeChildren();
    dispatch(RESET_CURRENT_MEASUREMENT());
    const renderer = getRenderer();
    if (renderer) renderer.render(stage);
  }
};
